import { render, staticRenderFns } from "./ProjectsDashboard.vue?vue&type=template&id=373744ac"
import script from "./ProjectsDashboard.vue?vue&type=script&lang=js"
export * from "./ProjectsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports